module.exports = __webpack_public_path__ + "static/media/avisory.c12ee124.png";